import React, { useCallback, useMemo } from 'react';

import { useField } from 'formik';

import { twMerge } from 'tailwind-merge';
import dayjs from 'dayjs';

import type { Dayjs } from 'dayjs';

import Typography from 'components-new/typography/typography';
import type { DateInputProps } from 'components-new/date-input/date-input';
import DateInput from 'components-new/date-input/date-input';

interface DateInputFieldProps extends DateInputProps {
  name: string;
  placeholder?: string;
  inputClassName?: string;
  className?: string;
  disabled?: boolean;
  fieldName?: string;
}

const DateInputField: React.FC<DateInputFieldProps> = (props) => {
  const {
    name,
    className,
    disabled,
    fieldName = name,
    inputClassName,
    placeholder,
  } = props;

  const [field, meta, { setValue }] = useField(name);

  const onChange = useCallback((value?: Dayjs) => {
    const date = value?.format('YYYY-MM-DD');
    if (typeof field.value === 'object') {
      setValue({
        ...field.value,
        [fieldName]: date,
      });
    } else setValue(date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defaultValue = useMemo(() => {
    if (disabled) return undefined;
    let value: string;
    if (typeof field.value === 'object') value = field.value[fieldName];
    else value = field.value;

    if (!value) return undefined;

    return dayjs(value);
  }, [disabled, field.value, fieldName]);

  return (
    <div className={twMerge('flex flex-col gap-y-1 w-full', className)}>
      <DateInput
        inputClassName={inputClassName}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
      {meta.error && (
        <Typography
          as="p"
          variant="body-medium"
          className={twMerge('text-destructive mt-1')}
        >
          {meta.error}
        </Typography>
      )}
    </div>
  );
};

export default DateInputField;
